import axios from "axios";
import { API, authHeaders, parseDate, isoDate } from "./common";
import { geocode, routeInfo } from "./geo";

/** Human readable message from a DRF error response. */
export const apiError = (e, fallback = "Не удалось выполнить действие") => {
  const d = e?.response?.data;
  if (d && typeof d === "object") {
    if (d.error) return String(d.error);
    if (d.detail) return String(d.detail);
    const first = Object.entries(d)[0];
    if (first) return `${first[0]}: ${Array.isArray(first[1]) ? first[1][0] : JSON.stringify(first[1])}`;
  }
  return e?.message && !e.response ? e.message : fallback;
};

export const patchOrder = (uuid, data) =>
  axios.patch(`${API}/orders/${uuid}/`, data, { headers: authHeaders() }).then((r) => r.data);

export const duplicateOrder = (uuid) =>
  axios.post(`${API}/duplicate_order/${uuid}/`, {}, { headers: authHeaders() }).then((r) => r.data);

const geoOf = (loc) => (loc && loc.lat != null ? { lat: loc.lat, lng: loc.lng } : null);

/**
 * Geo/route fields to PATCH when the user changed the addresses of `order`.
 * picked = {from, to} Places-autocomplete results (optional).
 * Returns {} when nothing changed; throws Error with a Russian message when an
 * address could not be resolved (so geo never goes inconsistent with the text).
 */
export async function routePatch(order, from, to, picked = {}) {
  const fromChanged = (from || "").trim() !== (order.from_address || "").trim();
  const toChanged = (to || "").trim() !== (order.to_address || "").trim();
  if (!fromChanged && !toChanged) return {};
  const resolve = async (text, p) => (p && p.address === text && p.lat != null ? p : geocode(text));
  let a = geoOf(order.location_from);
  let b = geoOf(order.location_to);
  let aInfo = null;
  let bInfo = null;
  if (fromChanged) {
    aInfo = await resolve(from.trim(), picked.from);
    if (!aInfo) throw new Error("Не удалось определить адрес «Откуда». Выберите вариант из подсказок.");
    a = geoOf(aInfo);
  }
  if (toChanged) {
    bInfo = await resolve(to.trim(), picked.to);
    if (!bInfo) throw new Error("Не удалось определить адрес «Куда». Выберите вариант из подсказок.");
    b = geoOf(bInfo);
  }
  const out = {
    from_address: from.trim(),
    to_address: to.trim(),
    location_from: a || {},
    location_to: b || {},
  };
  if (aInfo) {
    out.from_country = aInfo.country || null;
    out.from_country_code = aInfo.country_code || null;
  }
  if (bInfo) {
    out.to_country = bInfo.country || null;
    out.to_country_code = bInfo.country_code || null;
  }
  const info = a && b ? await routeInfo(a, b) : {};
  out.distance = info.distance || null;
  out.route_polyline = info.route_polyline || null;
  if (info.from_country) {
    out.from_country = info.from_country;
    out.from_country_code = info.from_country_code;
  }
  if (info.to_country) {
    out.to_country = info.to_country;
    out.to_country_code = info.to_country_code;
  }
  return out;
}

/** loading window of the copy: new from_date, keep the original window length */
export const shiftWindow = (order, dateIso) => {
  const f = parseDate(order.from_date);
  const t = parseDate(order.to_date);
  const out = { from_date: dateIso };
  if (f && t) {
    const d = parseDate(dateIso);
    d.setDate(d.getDate() + Math.round((t - f) / 86400000));
    out.to_date = isoDate(d);
  } else {
    out.to_date = dateIso;
  }
  return out;
};

export const fmtResponse = (sec) => {
  if (sec == null) return null;
  if (sec < 60) return `${sec} сек`;
  if (sec < 3600) return `${Math.round(sec / 60)} мин`;
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  return m ? `${h} ч ${m} мин` : `${h} ч`;
};
